import { Navigate } from 'react-router-dom';
import { useMe } from '@/lib/auth';

/**
 * UI-level gate for /admin/* — redirects non-admins to the dashboard.
 * Convenience only: real enforcement is the backend RolesGuard on every
 * /api/admin/* endpoint.
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const me = useMe();
  if (me.isLoading) return null;
  if (!me.data?.roles?.includes('admin')) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
